import React from 'react';
import { Route } from 'react-router-dom';

function RouteWithSubRoutes(route) {

  const { path, exact } = route;

  return (
    <Route
      path={path}
      exact={exact}
      render={(props) => <route.component {...props} routes={route.routes} />}
    />
  );

}

export default RouteWithSubRoutes;
